/**
 * Attendance status label mapping
 */

export type AttendanceStatusType =
  'CLOCKED_IN' | 'ON_BREAK' | 'CLOCKED_OUT' | 'ABSENT' | 'NOT_CLOCKED_IN';

/**
 * Map attendance status to Korean label
 */
export function getAttendanceStatusLabel(status: AttendanceStatusType): string {
  switch (status) {
    case 'CLOCKED_IN':
      return '근무 중';
    case 'ON_BREAK':
      return '휴식 중';
    case 'CLOCKED_OUT':
      return '퇴근';
    case 'ABSENT':
      return '결근';
    case 'NOT_CLOCKED_IN':
      return '미출근';
    default:
      return '-';
  }
}
